import {Box, Chip, CircularProgress, Tooltip, Typography} from "@mui/material";
import {useEffect, useState} from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import * as lod from 'lodash'
import {BASE_URL} from "../../../../consts/BaseUrl";
import httpReq from "../../../../services/httpReq";
import {useParams} from "react-router-dom";

const Tags = ({addTagValueToNewReport, selectedTags,projectId}) => {
    const [tags, setTags] = useState([]);
    const params = useParams()

    // useEffect hook to handle the file upload
    useEffect(() => {

         httpReq('ProjectTag/GetList/'+projectId, 'GET', null, true).then((resSelected) => {
             const selectedTagIds = resSelected.responseData.map(r => r.tag.id);
            //
            httpReq('/Tag/GetList', 'GET', null, true).then(res => {
                if (!res || res.responseAnyError) return;
                const filterTags = [...res.responseData].filter(t => {
                    const idx = selectedTagIds.findIndex(selected => selected === t.id);
                    if(idx !== -1) {
                        return t;
                    }
                })
                const newTags = filterTags.map((item) => {
                    item.open = true;
                    item.values = item.values.map((value) => {
                        value.isLoading = false;
                        value.isLoaded = false;
                        return value;
                    });
                    return item;
                });
                const v = [...lod.orderBy(newTags, ['orderIndex'], 'asc')]
                setTags(v);
            });
        })


    }, []);

    const updateLoading = (tagIndex, tagValueIndex, isLoading) => {
        const newTags = [...tags];
        const tagValues = [...newTags[tagIndex].values];
        tagValues[tagValueIndex].isLoading = isLoading;
        newTags[tagIndex].values = tagValues;
        setTags(newTags);
    }

    const updateLoaded = (tagIndex, tagValueIndex, isLoading) => {
        const newTags = [...tags];
        const tagValues = [...newTags[tagIndex].values];
        tagValues[tagValueIndex].isLoaded = isLoading;
        newTags[tagIndex].values = tagValues;
        setTags(newTags);
    }

    const updateImage = (tagIndex, tagValueIndex, fileSrc) => {
        const newTags = [...tags];
        const tagValues = [...newTags[tagIndex].values];
        tagValues[tagValueIndex].fileSrc = fileSrc;
        newTags[tagIndex].values = tagValues;
        setTags(newTags);
    }

    useEffect(() => {
        tags.forEach((tag, tagIndex) => {
            const values = tag.values;
            values.forEach((value, tagValueIndex) => {
                if (value.isLoaded === false && value.isLoading === false && value.fileContent === '') {
                    updateLoading(tagIndex, tagValueIndex, true);
                    httpReq('/Tag/GetList', 'GET', null, true).then(res => {
                        if (!res || res.responseAnyError) return;
                        const tagValue = res.responseData;
                        if (tagValue.fileContent) {
                            const fileSrc = "data:" + tagValue.fileMimeType + ";base64," + tagValue.fileContent;

                            updateImage(tagIndex, tagValueIndex, fileSrc);
                        }

                        updateLoading(tagIndex, tagValueIndex, false);
                        updateLoaded(tagIndex, tagValueIndex, true);
                    });
                }
            })
        })

    }, [tags])

    const toggleTagOpen = (tagIndex) => {

        let newTags = tags.map((tag, idx) => {
            if (idx === tagIndex) {
                tag.open = !tag.open;
            } else {
                tag.open = false;
            }
            return tag;
        })

        // newTags[tagIndex].open = !newTags[tagIndex].open;
        setTags(newTags);
    }

    const isInSelectedTagValues = (tag) => {
        const founded = selectedTags.find(t => t.id === tag.id)
        return !!founded
    }


    return (
        <Box
            sx={{
                display: 'flex',
                gap: 1,
                flexDirection: 'row',
                marginTop: 1,
                overflowX: 'auto',
                p: 2,
                borderRadius: 4,
                boxShadow: 3,
                bgcolor: 'background.default',
                borderRight: '1px solid lightgray',
                width: '100%',
                height: '30vh'
            }}
        >
            {
                tags.map((tag, tagIndex) => {
                    return (
                        <Card sx={{
                            width: '10vw',
                            minHeight: '20vh',
                            overflowY: 'auto',
                            // borderRadius: 4,
                            boxShadow: 0.5,
                            bgcolor: 'background.default',
                            borderRight: '1px solid lightgray'
                        }} key={'card-' + tagIndex}>
                            {/*<CardMedia*/}
                            {/*    component="img"*/}
                            {/*    alt="tag"*/}
                            {/*    height="70"*/}
                            {/*    width={10}*/}
                            {/*    image={tagImage}*/}
                            {/*/>*/}
                            <CardContent sx={{padding: '0 !important'}}>
                                <Box sx={[tag.open ? {pt: 1, pb: 1} : {pt: 1, pb: 1}]}>
                                    <Box display={'flex'} justifyContent={'center'}>
                                        <Typography gutterBottom variant="h5">{tag.name}</Typography>
                                    </Box>
                                    {/* sx={{width:'100%'}} onClick={() => toggleTagOpen(tagIndex)}>*/}
                                    {/*    <ListItemText>*/}
                                    {/*        <Typography gutterBottom  variant="h7">{tag.name}</Typography>*/}
                                    {/*    </ListItemText>*/}
                                    {/*    {tag.open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}*/}
                                    {/*</ListItem>*/}
                                    {tag.open &&
                                        <Box sx={{display: 'flex', flexDirection: 'column', gap: 1}}>
                                            {tag.values.map((tagValue) => {
                                                return (
                                                    tagValue.isLoading ?
                                                        <Tooltip title={tagValue.value}>
                                                        <Chip
                                                            onClick={() => {
                                                                addTagValueToNewReport(tag,tagValue)
                                                            }}
                                                            key={'tag-value-loading-' + tagValue.id}
                                                            icon={<CircularProgress color="primary" size={25}/>}
                                                            label={tagValue.value}
                                                            sx={{
                                                                cursor: 'pointer',
                                                                margin: '0 5px',
                                                                fontWeight: 'bold'
                                                            }}
                                                            variant="outlined"
                                                        /></Tooltip> :
                                                        tagValue.isLoaded && (tagValue.fileSrc && tagValue.fileSrc !== '') ?
                                                            <Tooltip title={tagValue.value}>
                                                            <Chip
                                                                key={'tag-value-' + tagValue.id}
                                                                onClick={() => {
                                                                    addTagValueToNewReport(tag,tagValue)
                                                                }}
                                                                sx={{
                                                                    cursor: 'pointer',
                                                                    margin: '0 10px',
                                                                    fontWeight: 'bold',
                                                                    backgroundColor: isInSelectedTagValues(tagValue) && tagValue.color
                                                                }}
                                                                icon={<img src={tagValue.fileSrc} style={{
                                                                    width: 24,
                                                                    height: 24,
                                                                    borderRadius: '50%'
                                                                }} alt={'tag-value-image'}/>}
                                                                label={tagValue.value}
                                                                variant="outlined"
                                                            />
                                                            </Tooltip>
                                                            :
                                                            <Tooltip title={tagValue.value}>
                                                            <Chip
                                                                onClick={() => {
                                                                    addTagValueToNewReport(tag,tagValue)
                                                                }}
                                                                sx={{
                                                                    cursor: 'pointer',
                                                                    color: isInSelectedTagValues(tagValue) ? 'white' : 'black',
                                                                    margin: '0 10px',
                                                                    fontWeight: 'bold',
                                                                    backgroundColor: isInSelectedTagValues(tagValue) && tagValue.color
                                                                }}
                                                                key={'tag-value-' + tagValue.id}
                                                                label={tagValue.value}
                                                                variant="outlined"
                                                            /></Tooltip>
                                                )
                                            })}
                                        </Box>
                                    }

                                </Box>
                            </CardContent>
                        </Card>
                    )
                })
            }
        </Box>

    )
}

export default Tags;